import { Location } from "@angular/common";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { iconsLibrary } from "../../../theme/constants";
import { EButtonType } from "../../data-types/button.enum";
import { ECoworkerView } from "../../data-types/coworker.enums";
import { EFooterStyleInput } from "../../data-types/footer.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { EActiveTab } from "../../data-types/tabs.enum";
import { CoworkerService } from "../../services/coworker.service";
import { CoworkingService } from "../../services/coworking.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { UserService } from "../../services/user.service";
import { showAlertAction } from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";

declare var H: any;
@Component({
  selector: "cowing-core-booking",
  templateUrl: "./booking.component.html",
  styleUrls: ["./booking.component.scss"],
})
export class BookingComponent implements OnInit {
  weekInMs: number = 604800000;
  monthInMs: number = 2592000000;
  @Input("coworkingId") coworkingId = null;
  private tokenRefreshed = false;
  private iconsLibrary;
  public durations = [];
  public selectedDuration = null;
  public spaces = [];
  public selectedSpace = null;
  public startDay = null;
  public finishDay = null;
  public endDay = null;
  public startHour = null;
  public finishHour = null;
  public openingHour = null;
  public EInputStyleType = EInputStyleType;
  public EButtonType = EButtonType;
  public public_price = 0;
  public private_price = 0;
  public is_my_company = false;
  public isError: boolean = false;
  public isClosed: boolean = false;
  public isClosedStart: boolean = false;
  public isClosedEnd: boolean = false;

  public coworking = null;

  constructor(
    private _store: Store<IAppState>,
    private _router: Router,
    private _location: Location,
    private translate: TranslateService
  ) {}
  ngOnInit() {
    this.getCoworking();
    this.getSpaces();
    this.tokenRefreshed = true;
  }

  public goBack() {
    this._router.navigate(['coworking-detail'], {
      queryParams: { coworkingId: this.coworking?.id },
    });
  }

  public canBooking() {
    return (
      this.startDay &&
      this.startHour &&
      this.finishDay &&
      this.finishHour &&
      this.selectedSpace &&
      this.selectedDuration
    );
  }

  public getCoworking() {
    CoworkingService.instance
      .getCoworkingInfo(this.coworkingId)
      .then((coworking) => {
        this.coworking = coworking;
      })
      .catch((error) => {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                error.status === 401
                  ? this.translate.instant("general.expired")
                  : error.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      });
  }

  public showConfirmation() {
    let correctDuration = this.selectedSpace.durations.find((elem) => {
      return elem.title === this.selectedDuration.title;
    });
    let bookingData = {
      duration_price_id: correctDuration.id,
      end_date: moment(this.finishDay).format("DD/MM/YYYY"),
      end_time: this.finishHour,
      public_price: this.public_price,
      private_price: this.private_price,
      is_my_company: this.is_my_company,
      start_date: moment(this.startDay).format("DD/MM/YYYY"),
      start_time: this.startHour,
    };
    this._store.dispatch(showLoadingAction({}));
    CoworkingService.instance
      .createBooking(bookingData)
      .then(() => {
        this._router.navigate(["booking-confirmation"]);
        this._store.dispatch(closeLoadingAction({}));
      })
      .catch((error) => {
        this._store.dispatch(closeLoadingAction({}));

        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                error.status === 401
                  ? this.translate.instant("general.expired")
                  : error.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      });
  }

  public setNewDuration(event) {
    this.selectedDuration = this.selectedSpace.durations.find((elem) => {
      return elem.title === event;
    });

    if (this.selectedDuration.unit !== "h") {
      let dayOfWeek: number = new Date(this.startDay).getDay();
      if (this.coworking) {
        if (dayOfWeek === 0) {
          this.setHours(this.coworking.hours[6]);
        } else {
          this.setHours(this.coworking.hours[dayOfWeek - 1]);
        }
        this.openingHour = this.coworking.hours[6];
      }
    } else {
      this.startHour = null;
      this.finishHour = null;
    }

    if (this.startDay !== null) {
      this.manageDates();
    }

    if (this.selectedSpace) {
      this.calculatePrice();
    }
    this.checkIsClosed();
  }

  private setHours(hour) {
    if (hour.start !== hour.end) {
      this.startHour = hour.start;
      this.finishHour = hour.end;
      this.isClosed = false;
    } else {
      this.startHour = null;
      this.finishHour = null;
      this.isClosed = true;
    }
  }

  private checkIsClosed() {
    this.isClosedStart = false;
    this.isClosedEnd = false;

    let startDay = new Date(this.startDay).getDay();
    let endDay = new Date(this.finishDay).getDay();

    let startHours = this.startHour && this.startHour.split(":")[0];
    let startMinutes = this.startHour && this.startHour.split(":")[1];

    let finishHours = this.finishHour && this.finishHour.split(":")[0];
    let finishMinutes = this.finishHour && this.finishHour.split(":")[1];

    let closeHour = "";
    let closeMinutes = "";

    if (startDay === 0) {
      closeHour =
        this.coworking.hours[this.coworking.hours.length - 1].end.split(":")[0];
      closeMinutes =
        this.coworking.hours[this.coworking.hours.length - 1].end.split(":")[1];
    } else {
      closeHour = this.coworking.hours[startDay - 1].end.split(":")[0];
      closeMinutes = this.coworking.hours[startDay - 1].end.split(":")[1];
    }

    if (closeHour === "00") {
      closeHour = "23";
      closeMinutes = "59";
    }

    // Start on sunday and start day is closed
    if (
      startDay === 0 &&
      this.coworking.hours[this.coworking.hours.length - 1].start ===
        this.coworking.hours[this.coworking.hours.length - 1].end
    ) {
      this.isClosedStart = true;
      this.isClosedEnd = true;
    }
    // Start on another day and start day is closed
    else if (
      this.coworking.hours[startDay - 1].start ===
      this.coworking.hours[startDay - 1].end
    ) {
      {
        this.isClosedStart = true;
        this.isClosedEnd = true;
      }
    }
    // Start on open day
    else {
      if (this.startHour) {
        // Check if finish hour is smaller than the start
        if (finishHours && startHours > finishHours) {
          this.isClosed = true;
        } else {
          // Is sunday and startHour is smaller than the openning time
          if (
            startDay === 0 &&
            startHours <
              +this.coworking.hours[
                this.coworking.hours.length - 1
              ].start.split(":")[0]
          ) {
            this.isClosedStart = true;
          }
          // Start hour is smaller than the opening time
          else if (
            startHours < this.coworking.hours[startDay - 1].start.split(":")[0]
          ) {
            this.isClosedStart = true;
          }
          // Same start hour is the same than the opening time but the minutes are smaller
          else if (
            startHours ===
              this.coworking.hours[startDay - 1].start.split(":")[0] &&
            startMinutes <
              this.coworking.hours[startDay - 1].start.split(":")[1]
          ) {
            this.isClosedStart = true;
          }
          // Opening time is okey
          else {
            this.isClosedStart = false;
          }
        }
      } else {
        this.isClosed = true;
      }

      if (this.finishHour) {
        // Start hour is bigger than finish hour
        if (startHours && startHours > finishHours) {
          this.isClosed = true;
        }
        // Hours are okey
        else {
          // Finish day is sunday and finish hour is bigger than the closing hour
          if (endDay === 0 && finishHours > closeHour) {
            this.isClosedEnd = true;
          }
          // Finish hour is bigger than the closing hour
          else if (finishHours > closeHour) {
            this.isClosedEnd = true;
          }
          // Same finish hour than closing time and smaller minutes
          else if (finishHours === closeHour && finishMinutes > closeMinutes) {
            this.isClosedEnd = true;
          }
          // Hours are in the interval
          else {
            this.isClosedEnd = false;
          }
        }
      }
      //start hour > end hour
      else {
        this.isClosed = true;
      }
    }

    this.isClosed = this.isClosedEnd || this.isClosedStart;
  }

  public setStartHours(event) {
    let startDay = new Date(this.startDay).getDay();
    if (
      startDay === 0 &&
      this.coworking.hours[6].start === this.coworking.hours[6].end
    ) {
      this.isClosedStart = true;
    } else if (
      this.coworking.hours[startDay - 1].start ===
      this.coworking.hours[startDay - 1].end
    ) {
      this.isClosedStart = true;
    } else {
      this.isClosedStart = false;
    }

    this.startHour = event;

    if (this.finishHour && this.checkHours() === 0) {
      this.isError = true;
    } else {
      this.isError = false;
    }

    this.calculatePrice();
    this.checkIsClosed();
  }

  public setFinishHours(event) {
    let endDay = new Date(this.endDay).getDay();
    if (
      endDay === 0 &&
      this.coworking.hours[6].start === this.coworking.hours[6].end
    ) {
      this.isClosedEnd = true;
    } else if (
      this.coworking.hours[endDay - 1].start ===
      this.coworking.hours[endDay - 1].end
    ) {
      this.isClosedEnd = true;
    } else {
      this.isClosedEnd = false;
    }

    this.finishHour = event;

    if (this.startHour && this.checkHours() === 0) {
      this.isError = true;
    } else {
      this.isError = false;
    }

    this.calculatePrice();
    this.checkIsClosed();
  }

  public manageDates() {
    if (this.selectedDuration) {
      if (
        this.selectedDuration.unit === "h" ||
        (this.selectedDuration.unit === "d" &&
          this.selectedDuration.value === 1)
      ) {
        this.finishDay = moment(this.startDay).format("yyyy-MM-DD");
      } else if (this.selectedDuration.unit === "d") {
        this.finishDay = moment(new Date(this.startDay.getTime()))
          .add(this.selectedDuration.value, "d")
          .format("yyyy-MM-DD");
      }
    }
  }

  public isHourEnabled() {
    if (this.selectedDuration) {
      return this.selectedDuration.unit === "h";
    }
    return true;
  }

  public setNewSpace(event) {
    if (event.hasOwnProperty("id")) {
      this.selectedSpace = event;
      this.durations = [];
      this.selectedSpace.durations.forEach((elem) => {
        this.durations.push(elem);
      });
      if (this.selectedDuration) {
        this.calculatePrice();
      }
    }
  }

  private calculatePrice() {
    let correctDuration = this.selectedSpace.durations.find((elem) => {
      return elem.title === this.selectedDuration.title;
    });
    if (this.selectedDuration.unit === "h") {
      if (this.checkHours() > 0) {
        this.public_price = correctDuration.public_price * this.checkHours();
        this.private_price = correctDuration.private_price * this.checkHours();
      }
    } else {
      this.public_price = correctDuration.public_price;
      this.private_price = correctDuration.private_price;
    }
  }

  private checkHours() {
    if (this.startHour && this.finishHour) {
      let startDate = new Date();
      startDate.setHours(this.startHour.split(":")[0]);
      startDate.setMinutes(this.startHour.split(":")[1]);

      let finishDate = new Date();
      finishDate.setHours(this.finishHour.split(":")[0]);
      finishDate.setMinutes(this.finishHour.split(":")[1]);

      let diffInMilliSeconds = finishDate.getTime() - startDate.getTime();
      let hours = Math.floor(diffInMilliSeconds / 3600000);
      let minutes = Math.floor(diffInMilliSeconds / 60000) % 60;
      if (minutes === 0) {
        return hours;
      }
    }
    return 0;
  }

  public setNewDay(event) {
    if (typeof event === "string") {
      console.log(event);
      this.startDay = new Date(event);

      if (this.selectedDuration !== null) {
        this.manageDates();
      }
    }
  }

  get inactiveSpaces() {
    return this.spaces.every((space) => space.status === 0) ? true : false;
  }
  private getSpaces() {
    CoworkingService.instance
      .getCoworkingSpacesByCoworker(this.coworkingId)
      .then((spaces) => {
        this.spaces = spaces;
      })
      .catch((error) => {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                error.status === 401
                  ? this.translate.instant("general.expired")
                  : error.data.error,
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
      });
  }

  public get getCloseIcon() {
    return `${iconsLibrary.closeLight}`;
  }
}
